import { Component, Input } from '@angular/core';
import { isImage } from '../../shared/constants';

@Component({
	selector: 'view-attachments',
	templateUrl: './view-attachments.component.html',
	styleUrl: './view-attachments.component.scss'
})
export class ViewAttachmentsComponent {
	@Input() attachmentsArr: any[] = [];
	@Input() showDelete = false;
	defaultIcon = "../../../assets/img/file.png";

	showAttachmentImage(name: string) {
		try {
			if (name.indexOf(".png") >= 0 || name.indexOf(".jpg") >= 0 || name.indexOf(".jpeg") >= 0) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	getName(name: any) {
		try {
			return name.split("/").pop();
		} catch (error) {
			return name;
		}
	}

	isImage(name) {
		return isImage(name);
	}

	getShortName(name: string) {
		name = this.getName(name);
		const limit = 20;
		const trail = '...';
		return name.length > limit ? name.substring(0, limit) + trail : name;
	}

	removeAttachment(att: any) {
		this.attachmentsArr.splice(this.attachmentsArr.indexOf(att), 1);
	}
}
